import type { ChartHalf } from '../../presenters/chart-of-accounts.presenter';

/** A value for one half of one account — picked. */
export interface ChartDecision {
    readonly accountId: string;
    readonly half: ChartHalf;
    readonly value: string;
}

/** The key a cell is tracked by while it saves or after its write failed. */
export function chartCellKey(accountId: string, half: ChartHalf): string {
    return `${accountId}:${half}`;
}
